import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_ENDPOINTS } from "../config/api";
import "../styles/SpiritualLinks.css";

const API_URL = API_ENDPOINTS.SPIRITUAL_LINKS;

function SpiritualLinks() {

  /* ================= STATE ================= */

  const [videos, setVideos] = useState([]);

  const [header, setHeader] = useState({
    title: "Spiritual Video Library",
    subtitle:
      "Watch divine events, blessings & devotional celebrations",
  });

  const [activeVideo, setActiveVideo] = useState("");
  const [activeDescription, setActiveDescription] = useState("");
  const [loading, setLoading] = useState(false);

  /* ================= FETCH DATA ================= */

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const res = await axios.get(API_URL);

        const data = res.data;

        if (data?.header) setHeader(data.header);

        if (Array.isArray(data?.videos)) {
          setVideos(data.videos);

          if (data.videos.length > 0) {
            setActiveVideo(data.videos[0].video_id);
            setActiveDescription(data.videos[0].description);
          }
        }

      } catch (error) {
        console.log("FETCH ERROR:", error.response?.data || error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  /* ================= VIDEO SWITCH ================= */

  const handleVideoChange = (video) => {
    setActiveVideo(video.video_id);
    setActiveDescription(video.description);
  };

  /* ================= YOUTUBE SAFE EMBED ================= */

  const getYoutubeId = (url) => {
    if (!url) return "";

    if (url.includes("youtu.be/")) {
      return url.split("youtu.be/")[1].split("?")[0];
    }

    if (url.includes("watch?v=")) {
      return url.split("watch?v=")[1].split("&")[0];
    }

    return url;
  };

  return (
    <div className="spiritual-container">

      {/* ================= HEADER ================= */}

      <div className="links-header">
        <h2>{header.title}</h2>
        <p>{header.subtitle}</p>
      </div>

      {/* ================= LOADING ================= */}

      {loading && <p>Loading videos...</p>}

      {/* ================= VIDEO PLAYER ================= */}

      {!loading && activeVideo && (
        <div className="video-section">

          <iframe
            width="100%"
            height="450"
            src={`https://www.youtube.com/embed/${getYoutubeId(activeVideo)}`}
            title="Spiritual Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>

        </div>
      )}

      {/* ================= DESCRIPTION ================= */}

      <div className="description-section">
        <h2>Spiritual Learning & Peace Hub</h2>

        <p
          style={{
            marginTop: "10px",
            fontSize: "14px",
            color: "#666",
            lineHeight: "1.6",
          }}
        >
          {activeDescription}
        </p>
      </div>

      {/* ================= VIDEO LIST ================= */}

      <div className="links-section">
        <h3>Available Videos</h3>

        <ul>
          {videos.map((video, index) => (
            <li key={index}>
              <button
                className={`video-link ${
                  activeVideo === video.video_id ? "active" : ""
                }`}
                onClick={() => handleVideoChange(video)}
              >
                ▶ {video.title}
              </button>
            </li>
          ))}
        </ul>
      </div>

    </div>
  );
}

export default SpiritualLinks;